import { render, staticRenderFns } from "./project_detail.vue?vue&type=template&id=18d2f5c4&scoped=true"
import script from "./project_detail.vue?vue&type=script&lang=js"
export * from "./project_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d2f5c4",
  null
  
)

export default component.exports